var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeyes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.2402 14.2766C30.6196 14.7497 30.8299 15.3646 30.8299 16C30.8299 16.6377 30.6196 17.2503 30.2402 17.7234C27.8402 20.6286 22.3773 26.2857 16.0002 26.2857C9.62304 26.2857 4.16018 20.6286 1.76018 17.7234C1.37432 17.2322 1.16643 16.6247 1.17047 16C1.17047 15.3646 1.38075 14.7497 1.76018 14.2766C4.16018 11.3714 9.62304 5.71429 16.0002 5.71429C22.3773 5.71429 27.8402 11.3714 30.2402 14.2766Z",
    stroke: "#515050",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 20.5714C17.2126 20.5714 18.3753 20.0898 19.2326 19.2325C20.0899 18.3752 20.5716 17.2124 20.5716 16C20.5716 14.7876 20.0899 13.6248 19.2326 12.7675C18.3753 11.9102 17.2126 11.4286 16.0001 11.4286C14.7877 11.4286 13.625 11.9102 12.7677 12.7675C11.9103 13.6248 11.4287 14.7876 11.4287 16C11.4287 17.2124 11.9103 18.3752 12.7677 19.2325C13.625 20.0898 14.7877 20.5714 16.0001 20.5714Z",
    stroke: "#515050",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeyes);
export default __webpack_public_path__ + "static/media/eyeyes.bf3612d29cae85951b5ff93cef8aed54.svg";
export { ForwardRef as ReactComponent };